import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Injectable({
  providedIn: 'root'
})

export class ThemeService {
  constructor(
  ) {
    if (localStorage.getItem('dark')) {
      this.setTheme(true);
    }
  }
  public toggleAppTheme(event) {
    this.setTheme(event.detail.checked);
  }

  public setTheme(darkMode: boolean) {
    if (darkMode) {
      localStorage.setItem('dark', '1');
      document.body.classList.add('dark');
    } else {
      localStorage.removeItem('dark');
      document.body.classList.remove('dark');
    }
    this.setThemeChanged(true);
  }

  // To refresh calendar data
  public getThemeChanged = new BehaviorSubject(false);
  isDataAvailable = this.getThemeChanged.asObservable();

  public setThemeChanged(value: boolean) {
    this.getThemeChanged.next(value);
  }
}
